import { Injectable } from "@angular/core";
import { AdminConsoleService } from "../services/admin-console/admin-console.service";
import { map, Observable } from "rxjs";
import { Router, UrlTree } from "@angular/router";

@Injectable({
    providedIn: "root",
})
export class AdminConsoleGuard {

    constructor(
        private adminConsoleService: AdminConsoleService,
        private router: Router
    ) { };

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.isAdmin();
    }

    private isAdmin(): Observable<boolean | UrlTree> {
        return this.adminConsoleService.getAdminStatus()
            .pipe(
                map((status) => status.isAdmin || this.router.createUrlTree(['/error']))
            );
    }
}